import { format, isValid, parseISO } from 'date-fns';

/** Coerce a stored value to `YYYY-MM-DD`, or return `null` if empty. */
export function toYyyyMmDd(value: string | undefined | null): string | null {
  if (value == null || !String(value).trim()) {
    return null;
  }
  const t = String(value).trim();
  const m = t.match(/^(\d{4}-\d{2}-\d{2})/);
  if (m) {
    const p = parseISO(m[1]);
    return isValid(p) ? m[1] : null;
  }
  const d = new Date(t);
  if (!isValid(d)) {
    return null;
  }
  return format(d, 'yyyy-MM-dd');
}

export function valueToDate(value: string | undefined | null, fallback: Date = new Date()): Date {
  const y = toYyyyMmDd(value ?? undefined);
  if (y) {
    const p = parseISO(y);
    if (isValid(p)) {
      return p;
    }
  }
  return Number.isNaN(fallback.getTime()) ? new Date() : fallback;
}

/** For trigger display on native. */
export function formatDateDisplay(yyyyMmDd: string | null | undefined): string {
  const y = toYyyyMmDd(yyyyMmDd ?? undefined);
  if (!y) {
    return '';
  }
  const p = parseISO(y);
  return isValid(p) ? format(p, 'MMM d, yyyy') : '';
}
